module.exports = __webpack_public_path__ + "static/media/10.41def71a.png";